<template>
  <v-layout row>
    <v-flex xs12>
      <v-toolbar app>
        <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
        <v-toolbar-title>Mis Paquetes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon to="/help">
          <v-icon>flaticon-information</v-icon>
        </v-btn>
        <v-btn v-if="showDelivery == true" icon to="/delivery-form">
          <v-icon>flaticon-food</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list two-line class="list-view" v-if="items.length > 0">
        <template v-for="(item) in items">
          <v-list-tile class="list-view-item" :key="item.id_" avatar ripple>
            <v-list-tile-content>
              <v-list-tile-title
                :class="'bg-' + item.colorestatus + ' pack-title'"
              >{{ item.desc_estatus_proceso }}</v-list-tile-title>
              <!-- <v-list-tile-sub-title class="text--primary">{{ item.headline }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="mb5">{{ item.subtitle }}</v-list-tile-sub-title>-->
              <span class="list-view-item-date">{{item.fec_creacion}}</span>
              <div class="custom-preogress-container">
                <v-progress-linear height="50" v-model="item.trackingestatus"></v-progress-linear>
                <div class="custom-preogress">
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step1.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step2.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step3.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step4.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step5.png" alt />
                  </div>
                  <div class="custom-preogress-item">
                    <img src="../assets/progress/step6.png" alt />
                  </div>
                </div>
              </div>
              <table
                v-bind:class="item.mostrar_boton != 0 ? 'has-btn pack-list-table' : 'pack-list-table mb-3'"
              >
                <tr>
                  <th>Contenido</th>
                  <td>{{item.contenido}}</td>
                </tr>
                <tr>
                  <th>Peso</th>
                  <td>{{item.peso + "lb" }}</td>
                </tr>
                <tr>
                  <th>Guia</th>
                  <td>{{item.guia}}</td>
                </tr>
                <tr>
                  <th>Numero de traking</th>
                  <td>{{item.tracking_number}}</td>
                </tr>
              </table>

              <v-btn
                block
                v-if="item.mostrar_boton == 0"
                :loading="loading"
                :disabled="loading"
                color="orange darken-1"
                class="white--text mb-3 mt-1"
                @click="pickFile(item.guia,item.id_)"
              >
                Cargar Factura
                <v-icon right dark>cloud_upload</v-icon>
              </v-btn>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <div v-else>
        <img src="../assets/nodatos.jpg" class="noData" alt v-if="noData" />
        <v-progress-circular :size="90" color="blue" indeterminate class="loading-center" v-else></v-progress-circular>
      </div>
    </v-flex>
    <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
  </v-layout>
</template>

<script>
import Helpers from "../utils/helpers";
import Server from "../utils/server";
import { mapState } from "vuex";
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      (newValue, oldValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
    this.$store.watch(
      (state, getters) => getters.profile,
      (newValue, oldValue) => {
        this.showDeliveryFc();
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }

    this.showDeliveryFc();
  },
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      noData: false,
      loading: false,
      imageFile: null,
      imageName: "",
      guia: null,
      idpack: null,
      showDelivery: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    profile: function() {
      return this.$store.getters.profile;
    }
  },
  methods: {
    showDeliveryFc() {
      if (this.profile.length > 0) {
        if (
          this.profile[0].domicilio != "" &&
          this.profile[0].domicilio != 0 &&
          this.profile[0].domicilio != "0" &&
          this.profile[0].domicilio != undefined
        ) {
          this.showDelivery = true;
        } else {
          this.showDelivery = false;
        }
      } else {
        this.showDelivery = false;
      }
    },
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoice,
        guia,
        idpack,
        this.currentUser.userName,
        this.getPacks
      );
    },
    onFilePicked() {
      this.loading = true;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          var formData = new FormData();
          formData.append("text1", this.currentUser.userName);
          formData.append("text3", this.currentUser.pushId);
          formData.append("device", window.MobileApi.device);
          formData.append("PARAMETRO2", this.guia);
          formData.append("PARAMETRO1", this.idpack);
          formData.append("photo", this.imageFile);
          this.$http.post(Server.uploadInvoice, formData).then(
            response => {
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        });
      }
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      this.$http.post(Server.packs, formData).then(
        response => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
